module.exports = function (app, mod) {
  return "<div class=\"game-playerbox-manager\"></div>";
};